/**
 * Config sub-tabs — equal-width Yardi / Product / Model at every breakpoint (responsive).
 */
import { EntityEditTabBar } from '@/components/ui/EntityEditTabBar'
import type {
  PropertyConfigSubTab,
  PropertyConfigSubTabsProps,
} from '../types'

export function PropertyConfigSubTabs({
  items,
  active,
  onSelect,
  children,
}: PropertyConfigSubTabsProps) {
  const tabs = items.map((item) => ({
    id: item.id,
    label: item.label,
    testId: `property-config-subtab-${item.id}`,
  }))

  return (
    <div data-testid="property-config-subtabs" className="min-w-0">
      {tabs.length > 0 ? (
        <EntityEditTabBar
          navTestId="property-config-subtab-nav"
          ariaLabel="Config sections"
          tabs={tabs}
          activeTab={active}
          onSelect={(id) => onSelect(id as PropertyConfigSubTab)}
          layout="equal"
          wrapClassName="px-0 sm:px-0"
        />
      ) : null}
      <div className="min-w-0 pt-4">{children}</div>
    </div>
  )
}
